import { useTranslation } from 'react-i18next';

import { SelfPickupIcon } from 'assets';
import { SectionContainer } from 'components/shared';
import { useStorageTypeLabels } from 'constants/storageType';
import { StorageOption } from 'interfaces';
import { Card } from 'storybook';

import styles from './SelectedStorageSection.module.css';

type SelectedStorageSectionProps = {
   storage: StorageOption;
};

const SelectedStorageSection = ({ storage }: SelectedStorageSectionProps) => {
   const { t } = useTranslation();
   const { STORAGE_TYPE_LABELS_SINGULAR } = useStorageTypeLabels();

   return (
      <SectionContainer title={t('order_summary.storage.title')}>
         <Card
            title={t('order_summary.storage.card_title')}
            icon={<SelfPickupIcon />}
            bottomContent={
               <p className={styles.cardText}>
                  {`${storage.label} (${STORAGE_TYPE_LABELS_SINGULAR[storage.value.storageType]})`}
               </p>
            }
            className={styles.card}
         />
      </SectionContainer>
   );
};

export default SelectedStorageSection;
